/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {ColumnState, FilterModel} from 'ag-grid-community';

/**
 * Defines the `Context` in which the user is working, typically represented
 * visually via individual Tabs.
 */
export enum Context {
  test = 'test',
  production = 'production',
  discovery = 'discovery'
};

/**
 * Defines the Grid States for which user settings are to be persisted for the
 * duration of the given session.
 */
export type GridState = {
  isInitialized: boolean,
  columnState: ColumnState[],
  preferredColumnState: ColumnState[],
  hasUpdate: boolean,
  refreshRequired: boolean,
  includeSubGroups: boolean,
  pageSize: number,
  filterModel: FilterModel | {},
}

export type PID = {
  firmwareParameterEnumValue: number
  firmwareParameterName: string
}

export enum Vehicle {
  ProfileManager = 'Profile Manager',
  VehicleManager = 'Vehicle Manager',
  OEMValidation = 'OEM Validation Rules'
};

export enum ProfileMode {
  view = 'view',
  edit = 'edit',
  create = 'create'
};

export type ProfileLookup = {
  year: number;
  make: number;
  model: number;
  engine: number;
  fuel: number;
};

export type DecodedYmmef = {
  year?: string;
  make?: string;
  model?: string;
  engine?: string;
  fuel?: string;
};

export type RecentDecodedVin = {
  label: string;
  ymmef: DecodedYmmef;
  decodedAt: number;
};

export type CanRequestsViewMode = 'view' | 'create' | 'json' | 'details';
